import i18n from 'i18n-js';
import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as alarmsActions from 'services/api/alarms';
import { getErrorMessage, parsePagination, isCancel } from 'utils';

const fetchAlarmsRequest = () => ({
  type: types.FETCH_ALARMS_REQUEST,
});

const fetchAlarmsSuccess = (payload) => ({
  type: types.FETCH_ALARMS_SUCCESS,
  payload,
});

const fetchAlarmsFailed = () => ({
  type: types.FETCH_ALARMS_FAILED,
});

export const fetchAlarms = (params, options) => {
  return async (dispatch) => {
    if (params.configurations) {
      const configurations = params.configurations;
      params.configurations = [];
      configurations.forEach((val) => {
        params.configurations.push(val.id);
      });
    }

    dispatch(fetchAlarmsRequest());

    const response = await alarmsActions.fetchAlarms(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchAlarmsSuccess({
          pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: getErrorMessage(response.data),
        })
      );

      dispatch(fetchAlarmsFailed(getErrorMessage(response.data)));
    }
  };
};

const fetchAlarmByIdRequest = () => ({
  type: types.FETCH_ALARM_BY_ID_REQUEST,
});

const fetchAlarmByIdSuccess = (payload) => ({
  type: types.FETCH_ALARM_BY_ID_SUCCESS,
  payload,
});

const fetchAlarmByIdFailed = () => ({
  type: types.FETCH_ALARM_BY_ID_FAILED,
});

export const fetchAlarmById = (id) => {
  return async (dispatch) => {
    dispatch(fetchAlarmByIdRequest());

    const response = await alarmsActions.fetchAlarmById(id);

    if (response.ok) {
      return dispatch(
        fetchAlarmByIdSuccess({
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );

    dispatch(fetchAlarmByIdFailed(getErrorMessage(response.data)));
  };
};

const fetchAlarmsTypesRequest = () => ({
  type: types.FETCH_ALARMS_TYPES_REQUEST,
});

const fetchAlarmsTypesSuccess = (payload) => ({
  type: types.FETCH_ALARMS_TYPES_SUCCESS,
  payload,
});

const fetchAlarmsTypesFailed = () => ({
  type: types.FETCH_ALARMS_TYPES_FAILED,
});

export const fetchAlarmsTypes = (params) => {
  return async (dispatch) => {
    dispatch(fetchAlarmsTypesRequest());

    const response = await alarmsActions.fetchAlarmsTypes(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchAlarmsTypesSuccess({
          pagination,
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );

    dispatch(fetchAlarmsTypesFailed(getErrorMessage(response.data)));
  };
};

const fetchUpdateAlarmRequest = () => ({
  type: types.FETCH_UPDATE_ALARM_REQUEST,
});

const fetchUpdateAlarmSuccess = (payload) => ({
  type: types.FETCH_UPDATE_ALARM_SUCCESS,
  payload,
});

const fetchUpdateAlarmFailed = () => ({
  type: types.FETCH_UPDATE_ALARM_FAILED,
});

export const fetchUpdateAlarm = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateAlarmRequest());

    const response = await alarmsActions.fetchUpdateAlarm(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('alarm.update_success_msg'),
        })
      );
      return dispatch(fetchUpdateAlarmSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );

    dispatch(fetchUpdateAlarmFailed(getErrorMessage(response.data)));
  };
};

const fetchUpdateAlarmsStatusRequest = () => ({
  type: types.FETCH_UPDATE_ALARMS_STATUS_REQUEST,
});

const fetchUpdateAlarmsStatusSuccess = (payload) => ({
  type: types.FETCH_UPDATE_ALARMS_STATUS_SUCCESS,
  payload,
});

const fetchUpdateAlarmsStatusFailed = () => ({
  type: types.FETCH_UPDATE_ALARMS_STATUS_FAILED,
});

export const fetchUpdateAlarmsStatus = (payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateAlarmsStatusRequest());

    const response = await alarmsActions.bulkChangeAlarmsStatus(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('alarms.multiple_close_msg'),
        })
      );
      return dispatch(fetchUpdateAlarmsStatusSuccess(response?.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );

    dispatch(fetchUpdateAlarmsStatusFailed(getErrorMessage(response.data)));
  };
};
